module.exports = __webpack_public_path__ + "img/nyjl.515515de.png";